// src/components/Navbar.js
import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { NAV_LINKS, BRAND } from "../utils/constants";
import "./Navbar.css";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => { setMenuOpen(false); }, [location]);

  return (
    <nav className={`navbar ${scrolled ? "navbar--scrolled" : ""}`} role="navigation">
      <div className="navbar__inner container">

        {/* Logo */}
        <Link to="/" className="navbar__logo" aria-label="Sunaharco Home">
          <img
            src="/assets/logo-without-background.png"
            alt="Sunaharco"
            className="navbar__logo-img"
            onError={(e) => { e.target.style.display = "none"; }}
          />
          {/* <div className="navbar__logo-text">
            <span className="navbar__brand">{BRAND.name}</span>
            <span className="navbar__tagline">{BRAND.tagline}</span>
          </div> */}
        </Link>

        {/* Desktop Nav */}
        <ul className="navbar__links">
          {NAV_LINKS.map((link) => (
            <li key={link.to}>
              <Link
                to={link.to}
                className={`navbar__link ${location.pathname === link.to ? "navbar__link--active" : ""}`}
              >
                {link.label}
              </Link>
            </li>
          ))}
        </ul>

        {/* CTA */}
        <a href={`mailto:${BRAND.email.sales}`} className="btn btn-primary navbar__cta">
          Enquire Now
        </a>

        {/* Mobile hamburger */}
        <button
          className="navbar__hamburger"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle navigation"
          aria-expanded={menuOpen}
        >
          <span className={menuOpen ? "open" : ""} />
          <span className={menuOpen ? "open" : ""} />
          <span className={menuOpen ? "open" : ""} />
        </button>
      </div>

      {/* Mobile Menu */}
      <div className={`navbar__mobile ${menuOpen ? "navbar__mobile--open" : ""}`} aria-hidden={!menuOpen}>
        {NAV_LINKS.map((link) => (
          <Link key={link.to} to={link.to} className="navbar__mobile-link">
            {link.label}
          </Link>
        ))}
        <a
          href={`mailto:${BRAND.email.sales}`}
          className="btn btn-primary"
          style={{ margin: "0 20px 16px" }}
        >
          Enquire Now
        </a>
      </div>
    </nav>
  );
}
